import definitions from './pageDetailsDefinitions';

const usePageDetailsFactory = (defaultDetails) => {
  const pathMatch = definitions.usePathMatch();
  return definitions.pageDetailsDefinitions(defaultDetails)(pathMatch);
};

export { usePageDetailsFactory };
